import QuickDepositConfirm from './QuickDepositConfirm';

export default QuickDepositConfirm;
